module.exports = __webpack_public_path__ + "img/story5.391e2a02.jpeg";